var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('head-page'),_c('transition',{attrs:{"name":"head"}},[(_vm.headerFlag)?_c('div',{staticClass:"position_class"},[_c('head-page')],1):_vm._e()]),_c('transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1),_c('footer-page')],1)}
var staticRenderFns = []

export { render, staticRenderFns }